'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { Button, ButtonLoader } from '@qogita/ui/v2/button'
import { ComponentProps, useTransition } from 'react'
import { logoutAction } from 'src/core/data-layer/actions/logout'
import { Promisable } from 'type-fest'

export function LogoutButton({
  clickAction,
  children,
  ...props
}: {
  clickAction?: () => Promisable<void>
} & Pick<
  ComponentProps<typeof Button>,
  'variant' | 'size' | 'className' | 'children'
>) {
  const [isPending, startTransition] = useTransition()

  return (
    <Button
      type="submit"
      {...props}
      onClick={() => {
        startTransition(() => {
          logoutAction()
          clickAction?.()
        })
      }}
      isLoadingOverride={isPending}
    >
      <ButtonLoader>{children}</ButtonLoader>
    </Button>
  )
}
